var map = {
	"./about-page-hero.png": 7147,
	"./blog-page-hero.png": 1736,
	"./blogs-page-hero.png": 2339,
	"./careers-page-hero.png": 8285,
	"./casestudy-page-hero.png": 4027,
	"./contact-page-hero.png": 6576,
	"./home-page-hero.png": 4793,
	"./services-page-hero.png": 6820,
	"./work-page-hero.png": 8599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2397;